module.exports = __webpack_public_path__ + "img/pic_xiyiningzhu2.3870fa1a.png";